var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNorth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C11.1929 50 1.28392e-06 38.8071 1.88745e-06 25C2.49098e-06 11.1929 11.1929 -1.69631e-06 25 -1.09278e-06C38.8071 -4.89256e-07 50 11.1929 50 25C50 38.8071 38.8071 50 25 50Z",
    fill: "#1a76d2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4472 13.0125L35.4937 33.1054C35.6914 33.5009 35.3162 33.9396 34.8949 33.8055L25.4548 30.8018C25.1589 30.7077 24.8411 30.7077 24.5452 30.8018L15.1051 33.8055C14.6838 33.9396 14.3086 33.5009 14.5063 33.1054L24.5528 13.0125C24.737 12.6439 25.263 12.6439 25.4472 13.0125Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorth);
export default __webpack_public_path__ + "static/media/north.e41f045c1dc4b80c4d57e6539e471696.svg";
export { ForwardRef as ReactComponent };